module.exports = __webpack_public_path__ + "static/media/Cherubi_gaussian2.c37ba3ff.png";